import { render, staticRenderFns } from "./SidebarAddCrew.vue?vue&type=template&id=6d3d88bd&"
import script from "./SidebarAddCrew.vue?vue&type=script&lang=js&"
export * from "./SidebarAddCrew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports